import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

import type { BasketIngredientDetails } from '../../models/basket';

// NOTE: BasketStore purpose is to contain information about ingriedients excluded from itinerary.
export const useBasketStore = defineStore('BasketStore', () => {
  // State
  const excludedHotelTokens = ref<Record<string, BasketIngredientDetails>>({});

  // Actions
  function toggleHotelToken(token: BasketIngredientDetails): void {
    if (excludedHotelTokens.value[token.ingredientId]) {
      delete excludedHotelTokens.value[token.ingredientId];
    } else {
      excludedHotelTokens.value[token.ingredientId] = token;
    }
  }

  function resetHotelTokens(): void {
    excludedHotelTokens.value = {};
  }

  // Getters
  const excludedHotelTokensList = computed<string[]>(() =>
    Object.values(excludedHotelTokens.value).map(
      (token) => token.addToBasketToken
    )
  );

  return {
    // State
    excludedHotelTokens,

    // Actions
    toggleHotelToken,
    resetHotelTokens,

    // Getters
    excludedHotelTokensList,
  };
});
